export default "__VITE_ASSET__DLBJS$$e__"